<template #body="slotProps">
  <div class="card">
    <DataTable
      :value="tableData"
      :rows="rows"
      :paginator="true"
      :loading="isLoading"
      :rowsPerPageOptions="rowsPerPageOptions"
      lazy
      @page="onPaginate"
      :currentPage="currentPage"
      :totalRecords="totalRecords"
    >
      <template #header>
       
          <div class="card-toolbar w-full row">
                    <span class="p-input-icon-left">
              <i class="pi pi-search"/>
              <InputText
                  v-model="docNameModel"
                  placeholder="Rechercher un document"
                  @keyup.enter="onFilterDt"
                  @input="onClearInputDocName"
              />
           </span>
            <span class="p-input-icon-left ml-4">
              <i class="pi pi-search"/>
              <InputText
                  v-model="productNameModel"
                  placeholder="Rechercher par produit"
                  @keyup.enter="onFilterDt"
                  @input="onClearInputProductName"
              />
            </span>
              <span class="p-input-icon-left ml-4">
                    <FormKit
                        type="autocomplete"
                        name="supplier"
                        placeholder="Sélectionner un fournisseur"
                        :options="searchSuppliers"
                        v-model="supplierModel"
                    />
                </span>
              <span class="p-input-icon-left ml-4">
              <i class="pi pi-search"/>
              <InputText
                  v-model="orderNumberModel"
                  placeholder="Rechercher par commande"
                  @keyup.enter="onFilterDt"
                  @input="onClearInputOrderNumber"
              />
            </span>
          </div>

      </template>
      <div class="card-body pt-0">
        <Column field="docName" header="Nom du Document" />
        <Column field="productName" header="Nom du produit" />
        <Column field="productType" header="Type de produit" />
        <Column field="supplierName" header="Fournisseur" />
        <Column field="saleDate" header="Date de vente" />
        <Column field="orderNumber" header="Numéro de commande" />
        <Column field="userName" header="Nom du client" />
      </div>
      <template #empty>Aucun résultat trouvé.</template>
    </DataTable>
  </div>
</template>
<script setup lang="ts">
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import {ref, onMounted, watch} from "vue";
import {FilterMatchMode} from "primevue/api";
import {fetchDocumentsNotAvailable} from "@/_services/document/document";
import ApiService from "@/_services/api.service";

const isLoading = ref<boolean>(true);
const documents = Array<Document>();
const tableData = ref<Array<Document>>(documents);

const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const defaultRowsPerPage = 10;
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const docNameModel = ref<string>("");
let supplierModel = ref('');
let productNameModel = ref('')
let orderNumberModel = ref('')

onMounted(async () => {
    await populateDatatable();
});

async function populateDatatable() {
    let paramsFilter= {
        name: docNameModel.value,
        supplier:supplierModel.value,
        productName: productNameModel.value,
        orderNumber: orderNumberModel.value.trim()

    };
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchDocumentsNotAvailable(rows.value, page.value, paramsFilter);
    isLoading.value = loadingDt.value;
    tableData.value = tableDataDt.value;
    totalRecords.value = totalRecordsDt.value;
}

watch(
    supplierModel,
    (value) => {
        onFilterDt();
    });

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    await populateDatatable();
};
const onFilterDt = async () => {
    rows.value = 10;
    page.value = 1;
    await populateDatatable();
};

const onClearInputDocName = () => {
    if (docNameModel.value === ""  ) {
        rows.value = 10;
        page.value = 1;
        populateDatatable();
    }
};

const onClearInputProductName= () => {
    if ( productNameModel.value === "" ) {
        rows.value = 10;
        page.value = 1;
        populateDatatable();
    }
};

const onClearInputOrderNumber = () => {
    if (orderNumberModel.value === ""  ) {
        rows.value = 10;
        page.value = 1;
        populateDatatable();
    }
};
async function searchSuppliers({search}) {
    if (!search || search.length < 3) return [];
    const fetchSuppliers = await ApiService.get(`suppliers?name=${search || ''}&isActive=true`);
    return fetchSuppliers.data.data.map((val: any) => {
        return {
            label: val.name,
            value: val.uuid
        }
    });
}
</script>